module.exports = __webpack_public_path__ + "img/setting.74afa8d4.svg";